export const message = {
  saveSlasSuccess: 'SLAs successfully saved',
  publishSlasSuccess: 'SLAs successfully published'
}